import { logoutUser } from "../../store/actions";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
const Notfound = () => {
    const navigate = useNavigate();
      const dispatch = useDispatch();
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "80vh", textAlign: "center" }}
    >
      <div
        style={{
          fontSize: "120px",
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        404
      </div>

      <h2 className="mt-3 mb-2">No Permissions Assigned</h2>

      <p className="text-muted mb-4" style={{ maxWidth: 480 }}>
        You don’t have permission to access any modules yet.  
        Please contact your administrator to assign the required permissions.
      </p>
        <button className="btn btn-primary mb-3" onClick={() => {dispatch(logoutUser(navigate));}}>Back to Login</button>
    </div>
  );
};

export default Notfound;
